// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2euBZ","actionsCol":"EnrolledClinics_actionsCol__heUzb"};